import LimitedStockModal from './LimitedStockModal';
import { shouldShowLimitedStockModal } from './LimitedStockModal.constants';

export default LimitedStockModal;
export { shouldShowLimitedStockModal };
